import { cn } from "@omni/utils/styles";

import { Label } from "@/components/Form/Base/label.component";
import { Dropdown } from "@/components/General/Dropdown/dropdown.component";
import { Col, ColumnProps } from "@/components/General/Grid/col.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props<T> = {
    name: string;
    dimension: string;
    setCalculationValue: (name: string, value: T) => void;
    value?: T | undefined;
    values: Array<{ value: T; label: string }>;
    sm?: ColumnProps;
    md?: ColumnProps;
    lg?: ColumnProps;
    classNames?: string;
};

const CalculationDropDownField = <T,>({
    name,
    dimension,
    values,
    setCalculationValue,
    value,
    sm,
    md,
    lg,
    classNames
}: Props<T>) => {
    const { t } = useGranite();

    const label =
        values.find((v) => v.value === value)?.label ||
        values.at(0)?.label ||
        "";

    return (
        <Col
            sm={sm}
            md={md}
            lg={lg}
            className={cn("mt-3", classNames)}
        >
            <Label htmlFor={name}>{t(`calculator.${dimension}`)}</Label>
            <Dropdown
                placement={"bottom"}
                isLabel={true}
            >
                <Dropdown.Toggle>
                    <Dropdown.Label>{label}</Dropdown.Label>
                    <Dropdown.Caret />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {values.map(({ value, label }) => (
                        <Dropdown.Item
                            key={`${name}.${value}`}
                            onClick={() => setCalculationValue(name, value)}
                            label={label}
                        />
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        </Col>
    );
};

export default CalculationDropDownField;
